import { render, staticRenderFns } from "./HotelDetailsView.vue?vue&type=template&id=5d7127e8&scoped=true"
import script from "./HotelDetailsView.vue?vue&type=script&lang=js"
export * from "./HotelDetailsView.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailsView.vue?vue&type=style&index=0&id=5d7127e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7127e8",
  null
  
)

export default component.exports